import React from 'react';

import { ReactComponent as EnergicCaffeeActive } from '../assets/icons/amenities/caffee-color-icon.svg';
import { ReactComponent as EnergicCarWashActive } from '../assets/icons/amenities/car-wash-color-icon.svg';
import { ReactComponent as EnergicCarwashActive } from '../assets/icons/amenities/carwash-active.svg';
import { ReactComponent as EnergicGasActive } from '../assets/icons/amenities/gas-item-color-icon.svg';
import { ReactComponent as EnergicGasStationActive } from '../assets/icons/amenities/gas-station-active.svg';
import { ReactComponent as EnergicLockerActive } from '../assets/icons/amenities/locker-active.svg';
import { ReactComponent as EnergicLoungeActive } from '../assets/icons/amenities/lounge-active.svg';
import { ReactComponent as EnergicRelasingActive } from '../assets/icons/amenities/relasing-color-icon.svg';
import { ReactComponent as EnergicRestaurantActive } from '../assets/icons/amenities/restaurant-active.svg';
import { ReactComponent as EnergicRestroomActive } from '../assets/icons/amenities/restroom-color-icon.svg';
import { ReactComponent as EnergicSettingActive } from '../assets/icons/amenities/setting-color-icon.svg';
import { ReactComponent as EnergicShoppingActive } from '../assets/icons/amenities/shopping-color-icon.svg';
import { ReactComponent as VoltieCaffeeActive } from '../assets/icons/amenities/voltie/caffee-color-icon.svg';
import { ReactComponent as VoltieCarWashActive } from '../assets/icons/amenities/voltie/car-wash-color-icon.svg';
import { ReactComponent as VoltieGasActive } from '../assets/icons/amenities/voltie/gas-item-color-icon.svg';
import { ReactComponent as VoltieLoungeActive } from '../assets/icons/amenities/voltie/lounge-active.svg';
import { ReactComponent as VoltieRelasingActive } from '../assets/icons/amenities/voltie/relasing-color-icon.svg';
import { ReactComponent as VoltieRestaurantActive } from '../assets/icons/amenities/voltie/restaurant-active.svg';
import { ReactComponent as VoltieRestroomActive } from '../assets/icons/amenities/voltie/restroom-color-icon.svg';
import { ReactComponent as VoltieSettingActive } from '../assets/icons/amenities/voltie/setting-color-icon.svg';
import { ReactComponent as VoltieShoppingActive } from '../assets/icons/amenities/voltie/shopping-color-icon.svg';
import { ReactComponent as VoltieWifiActive } from '../assets/icons/amenities/voltie/wifi-color-icon.svg';
import { ReactComponent as EnergicWifiActive } from '../assets/icons/amenities/wifi-color-icon.svg';
import { ReactComponent as EnergicWorkshopActive } from '../assets/icons/amenities/workshop-active.svg';
import { ReactComponent as VoltieCurrencyIcon } from '../assets/icons/currency-icon.svg';
import { ReactComponent as EnergicCurrentPrice } from '../assets/icons/current-price-sae.svg';
import { ReactComponent as VoltieCurrentPrice } from '../assets/icons/currentPrice.svg';
import { ReactComponent as EnergicActiveClockIcon } from '../assets/icons/dashboard/clock-icon.svg';
import { ReactComponent as EnergicActiveConnectorIcon } from '../assets/icons/dashboard/connector-icon.svg';
import { ReactComponent as EnergicActiveDeviceIcon } from '../assets/icons/dashboard/device-icon.svg';
import { ReactComponent as EnergicCardEnergyIcon } from '../assets/icons/dashboard/map-energy-icon.svg';
import { ReactComponent as EnergicCardRevenueIcon } from '../assets/icons/dashboard/map-revenue-icon.svg';
import { ReactComponent as EnergicCardMultiUserIcon } from '../assets/icons/dashboard/map-user-icon.svg';
import energicStatinLocator from '../assets/icons/dashboard/station-locator.svg';
import { ReactComponent as EnergicFacility } from '../assets/icons/facility-color-icon.svg';
import { ReactComponent as EnergicLoginBanner } from '../assets/icons/login-banner.svg';
import { ReactComponent as EnergicMultiUser } from '../assets/icons/multi-users.svg';
import { ReactComponent as EnergicContactIcon } from '../assets/icons/profile/contact.svg';
import { ReactComponent as EnergicFacilityIcon } from '../assets/icons/profile/facility.svg';
import { ReactComponent as EnergicCurrency } from '../assets/icons/profile/sar.svg';
import { ReactComponent as EnergicWalletIcon } from '../assets/icons/profile/wallet-minus.svg';
import { ReactComponent as EnergicWithdrawalHistoryIcon } from '../assets/icons/profile/withdrawalHistory.svg';
import { ReactComponent as EnergicCheckBoxActiveIcon } from '../assets/icons/radio-active-icon.svg';
import { ReactComponent as EnergicCheckBoxIcon } from '../assets/icons/radio-button-icon.svg';
import { ReactComponent as EnergicCurrencyIcon } from '../assets/icons/sar-currency.svg';
import { ReactComponent as VoltieDashboardClockIcon } from '../assets/icons/voltie/dashboard/clock-icon.svg';
import { ReactComponent as VoltieDashboardConnectorIcon } from '../assets/icons/voltie/dashboard/connector-icon.svg';
import { ReactComponent as VoltieDashboardDeviceIcon } from '../assets/icons/voltie/dashboard/device-icon.svg';
import { ReactComponent as VoltieCardEnergyIcon } from '../assets/icons/voltie/dashboard/map-energy-icon.svg';
import { ReactComponent as VoltieCardRevenueIcon } from '../assets/icons/voltie/dashboard/map-revenue-icon.svg';
import { ReactComponent as VoltieCardMultiUserIcon } from '../assets/icons/voltie/dashboard/map-user-icon.svg';
import { ReactComponent as VoltieFacility } from '../assets/icons/voltie/facility-color-icon.svg';
import { ReactComponent as VoltieLoginBanner } from '../assets/icons/voltie/login-banner.svg';
import { ReactComponent as VoltieMultiUser } from '../assets/icons/voltie/multi-users.svg';
import { ReactComponent as VoltieCheckBoxActiveIcon } from '../assets/icons/voltie/radio-active-icon.svg';
import { ReactComponent as VoltieCheckBoxIcon } from '../assets/icons/voltie/radio-button-icon.svg';
import voltieStatinLocator from '../assets/icons/voltie/station-locator.svg';
import energicAdminLogo from '../assets/images/admin.png';
import energicCardsCar from '../assets/images/dashboard/cards-car.png';
import energicChargingDevice from '../assets/images/dashboard/energic-device.png';
import voltieChargingDevice from '../assets/images/dashboard/volti-device.png';
import energicDevicesLogo from '../assets/images/devices.png';
import EnergicEmptyCharger from '../assets/images/empty-charge-point.png';
import energicLogo from '../assets/images/logo.png';
import energicMobilityLogo from '../assets/images/mobility.png';
import energicNetworksLogo from '../assets/images/networks.png';
import energicQRLogo from '../assets/images/qr-logo.png';
import voltieLogo from '../assets/images/voltie-logo.png';
import { ReactComponent as VoltieCarwashActive } from '../assets/voltie/icons/amenities/carwash-active.svg';
import { ReactComponent as VoltieGasStationActive } from '../assets/voltie/icons/amenities/gas-station-active.svg';
import { ReactComponent as VoltieLockerActive } from '../assets/voltie/icons/amenities/locker-active.svg';
import { ReactComponent as VoltieWorkshopActive } from '../assets/voltie/icons/amenities/workshop-active.svg';
import { ReactComponent as VoltieContactIcon } from '../assets/voltie/icons/profile/contact.svg';
import { ReactComponent as VoltieCurrency } from '../assets/voltie/icons/profile/currency-icon.svg';
import { ReactComponent as VoltieFacilityIcon } from '../assets/voltie/icons/profile/facility.svg';
import { ReactComponent as VoltieWalletIcon } from '../assets/voltie/icons/profile/wallet-minus.svg';
import { ReactComponent as VoltieWithdrawalHistoryIcon } from '../assets/voltie/icons/profile/withdrawalHistory.svg';
import voliteCardsCar from '../assets/voltie/images/dashboard/cards-car.png';
import VoltieEmptyCharger from '../assets/voltie/images/empty-charge-point.png';
import voltieQRLogo from '../assets/voltie/images/qr-logo.png';
import { useBranding } from '../contexts/BrandingContext';

import { branding } from './enum';
import generatedBranding from './generatedBranding';

export const appCurrentBranding = process.env.REACT_APP_BRANDING || 'voltie';

export const currentBrandKey =
  process.env.REACT_APP_BRANDING === generatedBranding.brandName
    ? generatedBranding.brandName
    : process.env.REACT_APP_BRANDING || branding.ENERGIC;

/**
 * Component to render a remote image.
 * @param {object} properties - The component properties.
 * @returns {any} The image element.
 */
function RemoteImage(properties: any) {
  const { src, alt = 'logo', ...rest } = properties;
  return React.createElement('img', {
    src,
    alt,
    style: { maxWidth: '100%', height: 'auto', display: 'block' },
    ...rest,
  });
}

/**
 * Interface for the branding configuration.
 */
export interface BrandConfig {
  images: {
    logo: string;
    logoDarkTheme: string;
    chargingDevice: string;
    emptyChargerImage: string;
    cardsCar: string;
    qrLogo: string;
  };
  icons: {
    LoginBanner: React.ComponentType<any>;
    CafeActive: React.ComponentType<any>;
    CarWashActive: React.ComponentType<any>;
    GasActive: React.ComponentType<any>;
    LoungeActive: React.ComponentType<any>;
    RelaxingActive: React.ComponentType<any>;
    RestaurantActive: React.ComponentType<any>;
    RestroomActive: React.ComponentType<any>;
    SettingActive: React.ComponentType<any>;
    GasStationActive: React.ComponentType<any>;
    ShoppingActive: React.ComponentType<any>;
    WifiActive: React.ComponentType<any>;
    MultiUser: React.ComponentType<any>;
    Facility: React.ComponentType<any>;
    stationLocator: string;
    dashboardClock: React.ComponentType<any>;
    dashboardGas: React.ComponentType<any>;
    dashboardCharge: React.ComponentType<any>;
    dashboardElectricity: React.ComponentType<any>;
    dashboardRevenue: React.ComponentType<any>;
    dashboardMultiUser: React.ComponentType<any>;
    cardEnergyIcon: React.ComponentType<any>;
    cardRevenueIcon: React.ComponentType<any>;
    cardMultiUserIcon: React.ComponentType<any>;
    CheckBoxActiveIcon: React.ComponentType<any>;
    CheckBoxIcon: React.ComponentType<any>;
    currencyIcon: React.ComponentType<any>;
    LockerActive: React.ComponentType<any>;
    WorkshopActive: React.ComponentType<any>;
    CarwashActive: React.ComponentType<any>;
    CurrentPriceIcon: React.ComponentType<any>;
    CaffeeActive: React.ComponentType<any>;
    facilityIcon: React.ComponentType<any>;
    contactIcon: React.ComponentType<any>;
    WalletIcon: React.ComponentType<any>;
    withdrawalHistoryIcon: React.ComponentType<any>;
    dollarCurrency: React.ComponentType<any>;
  };
  meta: {
    latLong: { lat: number; lng: number };
    title: string;
    description: string;
    favicon: string;
    footerText: boolean;
  };
  text: {
    currency: string;
  };
}

const PortalType = {
  CPO: 'cpo',
  PARTNER: 'partner',
  EMSP: 'mobility',
  CHARGER: 'devices',
  USERS: 'users',
  APP: 'app',
  NETWORKS: 'networks',
};

/**
 * Dynamic Energic Logo
 */
const getDynamicEnergicLogo = () => {
  const { host } = globalThis.location;

  if (host.includes(PortalType.CPO)) return energicNetworksLogo;
  if (host.includes(PortalType.NETWORKS)) return energicNetworksLogo;
  if (host.includes(PortalType.EMSP)) return energicMobilityLogo;
  if (host.includes(PortalType.CHARGER)) return energicDevicesLogo;
  if (host.includes(PortalType.PARTNER)) return energicLogo;
  if (host.includes(PortalType.APP)) return energicAdminLogo;
  return energicLogo;
};

// Define image and icon mappings for each brand
const brandMapping: Record<string, BrandConfig> = {
  [branding.ENERGIC]: {
    images: {
      logo: getDynamicEnergicLogo(),
      logoDarkTheme: getDynamicEnergicLogo(),
      chargingDevice: energicChargingDevice,
      emptyChargerImage: EnergicEmptyCharger,
      cardsCar: energicCardsCar,
      qrLogo: energicQRLogo,
    },
    icons: {
      LoginBanner: EnergicLoginBanner,
      CafeActive: EnergicCaffeeActive,
      CarWashActive: EnergicCarWashActive,
      GasActive: EnergicGasActive,
      LoungeActive: EnergicLoungeActive,
      RelaxingActive: EnergicRelasingActive,
      RestaurantActive: EnergicRestaurantActive,
      RestroomActive: EnergicRestroomActive,
      SettingActive: EnergicSettingActive,
      GasStationActive: EnergicGasStationActive,
      ShoppingActive: EnergicShoppingActive,
      WifiActive: EnergicWifiActive,
      MultiUser: EnergicMultiUser,
      Facility: EnergicFacility,
      stationLocator: energicStatinLocator,
      dashboardClock: EnergicActiveClockIcon,
      dashboardGas: EnergicActiveDeviceIcon,
      dashboardCharge: EnergicActiveConnectorIcon,
      dashboardElectricity: EnergicCardEnergyIcon,
      dashboardRevenue: EnergicCardRevenueIcon,
      dashboardMultiUser: EnergicCardMultiUserIcon,
      cardEnergyIcon: EnergicCardEnergyIcon,
      cardRevenueIcon: EnergicCardRevenueIcon,
      cardMultiUserIcon: EnergicCardMultiUserIcon,
      CheckBoxActiveIcon: EnergicCheckBoxActiveIcon,
      CheckBoxIcon: EnergicCheckBoxIcon,
      currencyIcon: EnergicCurrencyIcon,
      LockerActive: EnergicLockerActive,
      WorkshopActive: EnergicWorkshopActive,
      CarwashActive: EnergicCarwashActive,
      CurrentPriceIcon: EnergicCurrentPrice,
      CaffeeActive: EnergicCaffeeActive,
      facilityIcon: EnergicFacilityIcon,
      contactIcon: EnergicContactIcon,
      WalletIcon: EnergicWalletIcon,
      withdrawalHistoryIcon: EnergicWithdrawalHistoryIcon,
      dollarCurrency: EnergicCurrency,
    },
    meta: {
      latLong: { lat: 24.7113281, lng: 46.6733308 },
      title: 'Energic - Super Admin',
      description:
        'Take control of your EV charging stations with Energic Control. This powerful web app offers seamless management, dynamic pricing, real-time monitoring, and smart scheduling to maximize efficiency and performance. Perfect for EV facility owners looking to streamline operations.',
      favicon: '/favicon_energic.ico',
      footerText: false,
    },
    text: {
      currency: 'SAR',
    },
  },
  [branding.VOLTIE]: {
    images: {
      logo: voltieLogo,
      logoDarkTheme: voltieLogo,
      chargingDevice: voltieChargingDevice,
      emptyChargerImage: VoltieEmptyCharger,
      cardsCar: voliteCardsCar,
      qrLogo: voltieQRLogo,
    },
    icons: {
      LoginBanner: VoltieLoginBanner,
      CafeActive: VoltieCaffeeActive,
      CarWashActive: VoltieCarWashActive,
      GasActive: VoltieGasActive,
      GasStationActive: VoltieGasStationActive,
      LoungeActive: VoltieLoungeActive,
      RelaxingActive: VoltieRelasingActive,
      RestaurantActive: VoltieRestaurantActive,
      RestroomActive: VoltieRestroomActive,
      SettingActive: VoltieSettingActive,
      ShoppingActive: VoltieShoppingActive,
      WifiActive: VoltieWifiActive,
      MultiUser: VoltieMultiUser,
      Facility: VoltieFacility,
      stationLocator: voltieStatinLocator,
      dashboardClock: VoltieDashboardClockIcon,
      dashboardGas: VoltieDashboardDeviceIcon,
      dashboardCharge: VoltieDashboardConnectorIcon,
      dashboardElectricity: VoltieCardEnergyIcon,
      dashboardRevenue: VoltieCardRevenueIcon,
      dashboardMultiUser: VoltieCardMultiUserIcon,
      cardEnergyIcon: VoltieCardEnergyIcon,
      cardRevenueIcon: VoltieCardRevenueIcon,
      cardMultiUserIcon: VoltieCardMultiUserIcon,
      CheckBoxActiveIcon: VoltieCheckBoxActiveIcon,
      CheckBoxIcon: VoltieCheckBoxIcon,
      currencyIcon: VoltieCurrencyIcon,
      LockerActive: VoltieLockerActive,
      WorkshopActive: VoltieWorkshopActive,
      CarwashActive: VoltieCarwashActive,
      CurrentPriceIcon: VoltieCurrentPrice,
      CaffeeActive: VoltieCaffeeActive,
      facilityIcon: VoltieFacilityIcon,
      contactIcon: VoltieContactIcon,
      WalletIcon: VoltieWalletIcon,
      withdrawalHistoryIcon: VoltieWithdrawalHistoryIcon,
      dollarCurrency: VoltieCurrency,
    },
    meta: {
      latLong: { lat: 41.8781, lng: -87.6298 },
      title: 'Voltie Power Up – Super Admin',
      description:
        'Take control of your EV charging stations with Voltie Power Up. This powerful web app offers seamless management, dynamic pricing, real-time monitoring, and smart scheduling to maximize efficiency and performance. Perfect for EV facility owners looking to streamline operations.',
      favicon: '/favicon_voltie.ico',
      footerText: false,
    },
    text: {
      currency: 'USD',
    },
  },
};

const defaultBrand: BrandConfig = brandMapping[branding.ENERGIC];

const baseBrandKey =
  (process.env.REACT_APP_BRANDING as keyof typeof brandMapping) || branding.ENERGIC;

let currentBrand: BrandConfig = brandMapping[baseBrandKey] ?? defaultBrand;

const hasValidApiBranding = generatedBranding?.isActive && !!generatedBranding?.urls?.logo;

if (hasValidApiBranding) {
  currentBrand = {
    ...currentBrand,
    images: {
      ...currentBrand.images,
      logo: generatedBranding.urls.logo,
    },
    icons: {
      ...currentBrand.icons,
      /**
       * Renders the dynamic login banner.
       * @param {object} properties - The component properties.
       * @returns {any} The login banner element.
       */
      LoginBanner: (properties: any) =>
        React.createElement(RemoteImage, {
          src: generatedBranding.urls.logo,
          alt: generatedBranding.meta.title,
          ...properties,
        }),
    },
    meta: {
      ...currentBrand.meta,
      title: generatedBranding.meta.title || currentBrand.meta.title,
      description: generatedBranding.meta.description || currentBrand.meta.description,
    },
  };
}

/**
 * Hook to get the current reactive branding.
 * @returns {any} The current reactive brand configuration.
 */
export const useAppBranding = (): BrandConfig => {
  const { brandData } = useBranding();

  const baseKey = (process.env.REACT_APP_BRANDING as keyof typeof brandMapping) || branding.ENERGIC;
  let brand = brandMapping[baseKey] ?? defaultBrand;

  if (brandData) {
    brand = {
      ...brand,
      images: {
        ...brand.images,
        logo: brandData.logo || brand.images.logo,
      },
      icons: {
        ...brand.icons,
        /**
         * Renders the dynamic login banner.
         * @param {object} properties - The component properties.
         * @returns {any} The login banner element.
         */
        LoginBanner: (properties: any) =>
          React.createElement(RemoteImage, {
            src: brandData.logo || brand.images.logo,
            alt: brandData.clientName || brand.meta.title,
            ...properties,
          }),
      },
      meta: {
        ...brand.meta,
        title: brandData.clientName || brand.meta.title,
        description: brandData.clientName || brand.meta.description,
        favicon: brandData.favicon || brand.meta.favicon,
        footerText: brandData.footer || brand.meta.footerText,
      },
    };
  }

  return brand;
};

export const {
  images: brandImage,
  icons: brandIcons,
  meta: metaValues,
  text: brandText,
} = currentBrand;
